<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter" id="il_1">
<img alt=" " class="calibre9" id="id-485009222029722587" src="Images/img0001.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?afddbd12